import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import {
  StyledReactPlayerWrapper,
  StyledShowreel, StyledShowReelTitle, StyledTitleContainer,
} from './Showreel.style';
import './play.css';
import ScrollDown from '../ScrollDown/ScrollDown';
import {useMobile, useMobileLandscape} from '../../queries';

function Showreel({ scrollToStars }) {
  const [muted, setMuted] = useState(true);
  const isMobileHook = useMobile();
  const [isMobile, setIsMobile] = useState(isMobileHook);
  const isMobilLandscape = useMobileLandscape();

  useEffect(() => {
    setIsMobile(isMobileHook);
  }, [isMobileHook]);

  const renderPreview = () => (
    <div style={{
      color: 'white', position: 'absolute', top: '35%', left: '50%', transform: 'translate(-50%,-50%)',
    }}
    >
      <span>
        <h1 style={{ display: 'inline' }}>
            Loading Showreel
        </h1>
        <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        <span className="sr-only">Loading Showreel...</span>
      </span>

    </div>
  );

  const handleClick = () => {
    setMuted(!muted);
  };

  return (
    <StyledShowreel>
      {renderPreview()}
      {!isMobile && (
        <StyledTitleContainer>
          <StyledShowReelTitle>
          SHOWREEL
          </StyledShowReelTitle>
          <i
            className={muted ? 'fas fa-volume-mute' : 'fas fa-volume-up'}
            onClick={handleClick}
          />
        </StyledTitleContainer>
      )}

      <StyledReactPlayerWrapper style={{ zIndex: 0 }}>
        <ReactPlayer
          className="react-player"
          url="https://vimeo.com/382114166"
          width="100%"
          height="100%"
          onStart={() => isMobile && muted && setMuted(false)}
          controls
          playing={!isMobile}
          volume={muted ? 0 : 1}
          muted={muted}
          loop
          config={{ vimeo: { playerOptions: { quality: 'auto', autoplay: !isMobile, responsive: true } } }}
        />
      </StyledReactPlayerWrapper>
      {!isMobile && !isMobilLandscape && <ScrollDown onClick={scrollToStars} />}

    </StyledShowreel>


  );
}

export default Showreel;
